import { useCallback } from 'react';
import { createDispatchHook, TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';
import type { RootState, AppDispatch } from '../store';

export const useDispatch = createDispatchHook<AppDispatch>();
export const useSelector = useReduxSelector as TypedUseSelectorHook<RootState>;

type TypedUseInstanceSelectorHook<TState> = <TSelected, TType>(
    selector: (state: TState, props: TType) => TSelected,
    props: TType
  ) => TSelected;

/**
 * Wraps useSelector so that it can also include an optional property
 */
export const useInstanceSelector: TypedUseInstanceSelectorHook<RootState> = (selector, props): typeof selectorData => {
    const selectorWithProps = useCallback(
        (state: RootState) => selector(state, props),
        [props, selector],
    );

    const selectorData = useSelector(selectorWithProps);

    return selectorData;
};